<script setup lang="ts">
import { computed } from 'vue';
import { Menu } from '~/types';

interface Props {
  item: Menu.MenuItem;
}

const props = defineProps<Props>();

const title = computed<string>(() => props.item.data?.title || props.item.name);
const url = computed<string | undefined>(() => props.item.data?.url);
</script>

<template>
  <li v-if="props.item.enabled" class="title-menu-item">
    <strong class="title-menu-item__title">
      <template v-if="url">
        <a :href="url" class="title-menu-item__title-link">
          {{ title }}
        </a>
      </template>
      <template v-else>
        {{ title }}
      </template>
    </strong>
    <ul class="title-menu-item__submenu">
      <template v-for="childrenMenuItem in props.item.children">
        <Component
          :is="childrenMenuItem.component"
          v-if="childrenMenuItem?.component"
          :key="childrenMenuItem.id"
          :item="childrenMenuItem"
        />
      </template>
    </ul>
  </li>
</template>

<style lang="scss" scoped>
.title-menu-item {
  @apply flex flex-col gap-3;

  &__submenu {
    @apply flex flex-col gap-1;
  }
}
</style>
